import React, { useEffect, useMemo, useState } from "react";

// Course enrollment deadline - 30 days from a fixed date (or dynamic)
// Using a fixed future target date for consistency. Change as needed.
const TARGET_DATE = "2026-08-31T23:59:59";

function diff(target) {
  const now = new Date().getTime();
  const t = new Date(target).getTime();
  let s = Math.max(0, Math.floor((t - now) / 1000));
  const days = Math.floor(s / 86400);
  s -= days * 86400;
  const hours = Math.floor(s / 3600);
  s -= hours * 3600;
  const minutes = Math.floor(s / 60);
  const seconds = s - minutes * 60;
  return { days, hours, minutes, seconds, total: t - now };
}

export default function Countdown({
  target = TARGET_DATE,
  variant = "light", // "light" | "dark"
  compact = false,
}) {
  const [t, setT] = useState(() => diff(target));

  useEffect(() => {
    const i = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(i);
  }, [target]);

  const isDark = variant === "dark";

  const boxes = useMemo(
    () => [
      { v: t.days, l: "Giorni" },
      { v: t.hours, l: "Ore" },
      { v: t.minutes, l: "Minuti" },
      { v: t.seconds, l: "Secondi" },
    ],
    [t]
  );

  if (compact) {
    return (
      <div className="inline-flex items-center gap-2">
        {boxes.map((b, i) => (
          <React.Fragment key={b.l}>
            <div className="flex flex-col items-center min-w-[42px]">
              <div className={`text-lg font-extrabold leading-none ${isDark ? "text-white" : "text-[#0a1f55]"}`}>
                {String(b.v).padStart(2, "0")}
              </div>
              <div className={`text-[9px] uppercase tracking-wider mt-0.5 ${isDark ? "text-slate-300" : "text-slate-500"}`}>
                {b.l}
              </div>
            </div>
            {i < boxes.length - 1 && (
              <span className={`text-lg font-extrabold ${isDark ? "text-[#fbbf24]" : "text-[#f59e0b]"}`}>:</span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-3">
      {boxes.map((b) => (
        <div
          key={b.l}
          className={`relative rounded-xl ${
            isDark
              ? "bg-white/[0.07] border border-white/15 backdrop-blur-sm"
              : "bg-white border border-slate-200"
          } px-2 py-3 sm:py-4 text-center overflow-hidden`}
        >
          <div className={`absolute inset-x-0 top-0 h-px ${isDark ? "bg-gradient-to-r from-transparent via-[#f59e0b]/50 to-transparent" : "bg-gradient-to-r from-transparent via-[#102a6b]/30 to-transparent"}`}></div>
          <div className={`text-3xl sm:text-4xl md:text-5xl font-extrabold leading-none tabular-nums ${isDark ? "text-white" : "text-[#102a6b]"}`}>
            {String(b.v).padStart(2, "0")}
          </div>
          <div className={`mt-1.5 text-[10px] sm:text-[11px] uppercase tracking-[0.18em] font-bold ${isDark ? "text-[#fbbf24]" : "text-[#f59e0b]"}`}>
            {b.l}
          </div>
        </div>
      ))}
    </div>
  );
}
